var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "34px",
    viewBox: "0 0 32 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "doc_share_upload_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0001 0.0002 26 0.0002 26 34 0.0001 34"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc_share_upload_2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOME",
    transform: "translate(-566.000000, -181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documenten_titel_map_raam",
    transform: "translate(353.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 762,
    height: 55
  }), /*#__PURE__*/React.createElement("text", {
    id: "2019-raamovereenkoms",
    fontFamily: "Gotham-Medium, Gotham",
    fontSize: 20,
    fontWeight: "normal",
    fill: "#F7893C"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 70,
    y: 35
  }, "2019 raamovereenkomsten")), /*#__PURE__*/React.createElement("g", {
    id: "folder_actief_icon",
    transform: "translate(23.000000, 8.000000)",
    fill: "#F7893C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.277,7 C18.228,7 19,7.772 19,8.724 L19,8.724 L19,12 L34.277,12 C35.228,12 36,12.772 36,13.724 L36,13.724 L36,32.276 C36,33.228 35.228,34 34.277,34 L34.277,34 L5.724,34 C4.772,34 4,33.228 4,32.276 L4,32.276 L4,13.724 C4,12.772 4.772,12 5.724,12 L5.724,12 L8.277,12 L8.277,8.724 C8.277,7.772 9.048,7 10,7 L10,7 Z M33,15 L7,15 L7,31 L33,31 L33,15 Z M17.001,9 L10.277,9 L10.277,12 L17.001,12 L17.001,9 Z",
    id: "Fill-1"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.8,
    fill: "#FFFFFF",
    x: 353,
    y: 157,
    width: 762,
    height: 555
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload_scherm",
    transform: "translate(501.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 466,
    height: 452
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(58.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc.icon_upload",
    transform: "translate(7.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload_icon_3pt",
    transform: "translate(17.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(7.500000, 10.000000) rotate(180.000000) translate(-7.500000, -10.000000) translate(6.000000, 5.000000)",
    fill: "#332E20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 3,
    height: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.37411839,9.15537671 C1.37411839,9.15537671 3.41607893,7.11341617 7.5,3.0294951 L13.6258816,9.15537671",
    id: "Path-6",
    stroke: "#332E20",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2761,0 C25.2281,0 26.0001,0.772 26.0001,1.724 L26.0001,1.724 L26.0001,17 L23.0001,17 L23.0001,3 L12.0001,3 L12.0001,9.276 C12.0001,10.778 10.7781,12 9.2761,12 L9.2761,12 L3.0001,12 L3.0001,31 L13.9991,31 L13.9991,34 L1.7241,34 C0.821257895,34 0.0817620499,33.3080222 0.00642132964,32.4248753 L0.0001,32.276 L0.0001,10 L10.0001,0 Z M10.0001,4.243 L4.2431,10 L9.2761,10 C9.6751,10 10.0001,9.675 10.0001,9.276 L10.0001,9.276 L10.0001,4.243 Z",
    id: "Combined-Shape",
    fill: "#332E20",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a315091661618739cd45ce38eaf8e8ff.svg";
export { ForwardRef as ReactComponent };